// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DIvr","toggle":"styles_toggle__3_Hwt","preview":"styles_preview__3sWtR"};